import React, { Suspense } from 'react';
import { ThemeProvider } from '@getgo/chameleon-web/react';
import { RegistrationWrapper } from './component/context/registrationContext';
import { EventWrapper } from './component/context/eventContext';
import { ConferenceWrapper } from './component/context/conferenceContext';
import { UserWrapper } from './component/context/userContext';
import RouterApp from './routerApp';
import { initializeMixpanel } from './mixpanel/mixpanelClient';
import FullScreenLoader from './component/utils/fullScreenLoader/FullScreenLoader';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

// Deprecated: Remove ThemeProvider from chameleon-chakra-ui

function App() {
  initializeMixpanel();
  return (
    <Suspense fallback={<FullScreenLoader />}>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider theme="light" style={{ height: '100vh' }}>
          <EventWrapper>
            <UserWrapper>
              <RegistrationWrapper>
                <ConferenceWrapper>
                  <RouterApp />
                </ConferenceWrapper>
              </RegistrationWrapper>
            </UserWrapper>
          </EventWrapper>
        </ThemeProvider>
      </I18nextProvider>
    </Suspense>
  );
}

export default App;
